import { render, staticRenderFns } from "./Scenic.vue?vue&type=template&id=1328615c&scoped=true"
import script from "./Scenic.vue?vue&type=script&lang=js"
export * from "./Scenic.vue?vue&type=script&lang=js"
import style0 from "./Scenic.vue?vue&type=style&index=0&id=1328615c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328615c",
  null
  
)

export default component.exports